import React from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const CustomModal1 = ({ open, handleClose, title, children  }) => {

    return (
        <div>
            <Modal
                open={open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                      handleClose();  // Only close when not clicking on the backdrop
                    }
                  }}
                disableEscapeKeyDown
                aria-labelledby="create-modal-title"
                aria-describedby="create-modal-description"
            >
                <Box sx={style}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography id="create-modal-title" variant="h6" component="h2">
                        {title}
                        </Typography>
                        <IconButton onClick={handleClose}>
                        <CloseIcon />
                        </IconButton>
                    </Box>

                    <Box sx={{ mt: 2 }}>{children}</Box>
              </Box>
            </Modal>
        </div>
    )
}

export default CustomModal1